export type CostChartViewMode = 'daily' | 'monthly';

export type CostChartDayRow = {
  /** `YYYY-MM-DD` */
  day: string;
  methodName: string;
  estimatedCosts?: number | null;
  inputTokens?: number | null;
  outputToken?: number | null;
};

export type CostChartMonthRow = {
  /** `YYYY-MM` */
  month: string;
  methodName: string;
  estimatedCosts?: number | null;
  inputTokens?: number | null;
  outputToken?: number | null;
};

export type CostChartProps = {
  mode: CostChartViewMode;
  onModeChange: (mode: CostChartViewMode) => void;
  fromDay: string;
  toDay: string;
  rangeLabel: string;
  canGoNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  dailyQuery: {
    data?: CostChartDayRow[];
    isLoading: boolean;
    isError: boolean;
  };
  monthlyQuery: {
    data?: CostChartMonthRow[];
    isLoading: boolean;
    isError: boolean;
  };
  monthlyCostLimit?: number | null;
  yearlyCostLimit?: number | null;
};

export type CostChartPoint = {
  label: string;
  cost: number;
  inputTokens: number;
  outputTokens: number;
  runningTotal?: number;
  [method: string]: string | number | undefined;
};

export function inputTokensKey(method: string): string {
  return `${method}__inputTokens`;
}

export function outputTokensKey(method: string): string {
  return `${method}__outputTokens`;
}
